import { MODULE_NAME } from '../../constants';

export const SUB_MODULE_NAME = `${MODULE_NAME}/userInfo`;

export const FETCH_RFP_MODULE_AVAILABLITY = 'FETCH_RFP_MODULE_AVAILABLITY';
export const RECEIVE_RFP_MODULE_AVAILABLITY = 'RECEIVE_RFP_MODULE_AVAILABLITY';
